import IconCirculeUser from "./IconCirculeUser.vue";
export default IconCirculeUser